$(".video-section__media").click(function(){
    $(".title-wrapper").hide();
})

$('.review_slider').slick({
  infinite: false,
  dots:true,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow: '.slide-arrow.arrow-prev',
  nextArrow: '.slide-arrow.arrow-next',
  dots: true,
  appendDots:'.slide-controls',
  dotsClass: 'custom-dots', //slick generates this <ul.custom-dots> within the appendDots container
  customPaging: function (slider, i) {
    //FYI just have a look at the object to find aviable information
    console.log(slider);
    var slideNumber = (i + 1),
        totalSlides = slider.slideCount;
    return '<a class="dot" role="button" title="' + slideNumber + ' of ' + totalSlides + '"><span class="string">' + slideNumber + '/' + totalSlides + '</span></a>';
  },
  responsive: [
    {
      breakpoint: 989,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


$(function(){
  $('#BlogTagFilter').on('change', function () {
  var url = $(this).val(); // get selected value
  if (url) { // require a URL
  window.location = url; // redirect
  }
  return false;
  });
});

jQuery(".footer-block--menu .footer-block__heading").click(function(){
  if($(window).width() <= '749'){
  if(jQuery(this).hasClass("show"))
        {
          jQuery(this).removeClass("show");jQuery(this).next().slideUp();}
  else
        {
          jQuery(".footer-block--menu .footer-block__heading").removeClass("show");
          jQuery(".footer-block--menu .footer-block__heading").next().slideUp();
          jQuery(this).addClass("show");jQuery(this).next().slideDown();
        }
    }
});

// for variant + Plus icon
let plutButtonElements = Array.from(document.getElementsByClassName('plus-btn'));
  plutButtonElements.forEach(function(element){
     element.addEventListener('click', function(event) {
        if(document.getElementById(this.dataset.id)){
          document.getElementById(this.dataset.id).classList.toggle('active');
          this.innerText = this.innerText.trim() == '+' ? '-' : '+';
        }
     });
  }); 

// End for variant + Plus icon


let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });




// $("input[type='radio']").click(function(){
//                   var radioValue = $("input[name='Color']:checked").val();
//                   if(radioValue){
//                       $('.var_label_info').text(radioValue)
//                   }
//               });


document.addEventListener("DOMContentLoaded", function() {
  var radioButtons = document.querySelectorAll("input[type='radio'][name='Color']");
  
  radioButtons.forEach(function(radioButton) {
    radioButton.addEventListener('click', function() {
      var checkedRadio = document.querySelector("input[name='Color']:checked");
      if (checkedRadio) {
        var radioValue = checkedRadio.value;
        document.querySelector('.var_label_info').textContent = radioValue;
      }
    });
  });
});

